import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-2.5,-0.5h1v0.5h-1zM1,-0.5h2v0.5h-2zM-3.5,0h2v0.5h-2zM1.5,0h2.5v0.5h-2.5zM-3.5,0.5h2.5v0.5h-2.5zM1,0.5h3v0.5h-3zM-3.5,1h7.5v0.5h-7.5zM-2.5,1.5h5.5v0.5h-5.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1,-12h0.5v0.5h-0.5zM-0.5,-11h1v1h-1zM-0.5,-10h1.5v9h-1.5zM0,-1h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M2,-14h1v0.5h-1zM-1.5,-12h0.5v0.5h-0.5zM-0.5,-11.5h1v0.5h-1zM-0.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M2,-14.5h1v0.5h-1zM1.5,-14h0.5v0.5h-0.5zM1.5,-13.5h2.5v0.5h-2.5zM0,-13h3v0.5h-3zM-0.5,-12.5h3.5v0.5h-3.5zM-2.5,-12h1v0.5h-1zM1,-12h1.5v0.5h-1.5zM-2,-11.5h1.5v0.5h-1.5zM0.5,-11.5h1.5v0.5h-1.5zM0.5,-11h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-0.5,-12h1.5v0.5h-1.5z',
    },
    {
      paint: 'rock',
      d: 'M-1,-1h0.5v0.5h-0.5zM-1.5,-0.5h2.5v0.5h-2.5zM-1.5,0h3v0.5h-3zM-1,0.5h2v0.5h-2z',
    },
  ],
  pixels: 171,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-2,-0.5h0.5v0.5h-0.5zM2.5,-0.5h0.5v0.5h-0.5zM-3.5,0h2v0.5h-2zM1.5,0h2.5v0.5h-2.5zM-3.5,0.5h2.5v0.5h-2.5zM1,0.5h3v0.5h-3zM-3.5,1h7.5v0.5h-7.5zM-2.5,1.5h5.5v0.5h-5.5z',
    },
    {
      paint: 'trunk',
      d: 'M1,-11.5h0.5v0.5h-0.5zM2,-11.5h0.5v0.5h-0.5zM0.5,-11h1v0.5h-1zM-3.5,-10h0.5v0.5h-0.5zM1,-10h1.5v9.5h-1.5zM-2.5,-9h1v0.5h-1zM-3,-8.5h1.5v8h-1.5zM-3,-0.5h1v0.5h-1zM1.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M4,-13.5h0.5v0.5h-0.5zM-5,-12h0.5v0.5h-0.5zM0.5,-11.5h0.5v0.5h-0.5zM2,-11h0.5v0.5h-0.5zM-1.5,-10h0.5v0.5h-0.5zM-3,-9.5h1v0.5h-1zM-3,-9h0.5v0.5h-0.5zM1,-0.5h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M3.5,-14h1v0.5h-1zM3.5,-13.5h0.5v0.5h-0.5zM4.5,-13.5h0.5v0.5h-0.5zM3,-13h2.5v1h-2.5zM-5.5,-12.5h1v0.5h-1zM-5.5,-12h0.5v0.5h-0.5zM-4.5,-12h0.5v0.5h-0.5zM1,-12h3.5v0.5h-3.5zM-6.5,-11.5h2.5v0.5h-2.5zM-1,-11.5h1.5v0.5h-1.5zM2.5,-11.5h2v0.5h-2zM-5.5,-11h1.5v0.5h-1.5zM-3.5,-11h1v0.5h-1zM-0.5,-11h1v0.5h-1zM2.5,-11h1.5v0.5h-1.5zM-5.5,-10.5h4v0.5h-4zM0,-10.5h3.5v0.5h-3.5zM-5,-10h1.5v0.5h-1.5zM-1,-10h1v0.5h-1zM-4.5,-9.5h1.5v0.5h-1.5zM-2,-9.5h1.5v0.5h-1.5zM-3.5,-9h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M1.5,-11.5h0.5v1h-0.5zM-3,-10h1.5v0.5h-1.5z',
    },
    {
      paint: 'rock',
      d: 'M-1,-1h1.5v0.5h-1.5zM-1.5,-0.5h2.5v0.5h-2.5zM-1.5,0h3v0.5h-3zM-1,0.5h2v0.5h-2z',
    },
  ],
  pixels: 270,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-2.5,-0.5h1v0.5h-1zM1,-0.5h2v0.5h-2zM-3.5,0h2v0.5h-2zM1.5,0h2.5v0.5h-2.5zM-3.5,0.5h2.5v0.5h-2.5zM1,0.5h3v0.5h-3zM-3.5,1h7.5v0.5h-7.5zM-2.5,1.5h5.5v0.5h-5.5z',
    },
    {
      paint: 'trunk',
      d: 'M0.5,-13h0.5v0.5h-0.5zM0,-12h0.5v0.5h-0.5zM-0.5,-11.5h1v0.5h-1zM-0.5,-11h1.5v10h-1.5zM0,-1h1v0.5h-1z',
    },
    {
      paint: [
        ['sail', 0.27],
        ['trunk', 0.73],
      ],
      d: 'M-3,-15h1v0.5h-1zM1,-13h0.5v0.5h-0.5zM-0.5,-12.5h1v0.5h-1zM-0.5,-12h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-3,-15.5h1v0.5h-1zM-2,-15h0.5v0.5h-0.5zM-4,-14.5h2.5v0.5h-2.5zM-3,-14h3v0.5h-3zM-3,-13.5h3.5v0.5h-3.5zM-2.5,-13h1.5v0.5h-1.5zM1.5,-13h1v0.5h-1zM-2,-12.5h1.5v0.5h-1.5zM0.5,-12.5h1.5v0.5h-1.5zM-1,-12h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.3],
        ['trunk', 0.7],
      ],
      d: 'M-1,-13h1.5v0.5h-1.5z',
    },
    {
      paint: 'rock',
      d: 'M-1,-1h0.5v0.5h-0.5zM-1.5,-0.5h2.5v0.5h-2.5zM-1.5,0h3v0.5h-3zM-1,0.5h2v0.5h-2z',
    },
  ],
  pixels: 177,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
